import { getApi, postApi } from '@/config/HttpService'
import ServiceEndpoints from '@/constants/ServiceEndpoints'
import { cache } from 'react'

export const getNavigationMenu = cache(async () => {
  return await getApi(ServiceEndpoints.getNavigationMenu)
})
export const getSlugDetail = cache(async (categoryUrl: any) => {
  return await postApi(ServiceEndpoints.getSlugDetail, { category_url: categoryUrl })
})
export const getSettingFilterData = cache(async (categoryId: any) => {
  return await postApi(ServiceEndpoints.getSettingFilters, {
    category_id: categoryId
  })
})
export const getSettingList = cache(async (payload: any) => {
  return postApi(ServiceEndpoints.getProductsByCategory, payload)
})
export const getProductDetail = cache(async (sku: string) => {
  return await postApi(ServiceEndpoints.getProductDetail, { sku }, false)
})
export const getRelatedProducts = cache(async (productIds: string) => {
  return await postApi(ServiceEndpoints.getRelatedProducts, { ids: productIds })
})

export const getDiamondFilterData = cache(async (categoryId: any) => {
  return await postApi(ServiceEndpoints.getDiamondFilters, {
    category_id: categoryId
  })
})

export const getDiamondList = cache(async (payload: any) => {
  return postApi(ServiceEndpoints.getProductsByCategory, payload)
})

export const getDiamondDetail = cache(async (sku: string) => {
  return await postApi(ServiceEndpoints.getProductDetail, { sku }, false)
})
export const fetchSearchData = cache(async (param: any) => {
  return await postApi(ServiceEndpoints.GetMainSearchList, param, false)
})
